import { useCallback, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import ColoredOverlayWindow from 'src/legacy/Components/Windows/ColoredOverlayWindow';

import { useEventData } from '../hooks';
import { useCartStore, useCheckoutStore } from '../stores';

import ReactPixel from 'react-facebook-pixel';
import ReactGA4 from 'react-ga4';
import { deleteCookie, getCookie } from 'src/utils/cookie';

const CheckoutSuccess = () => {
  const navigate = useNavigate();
  const existingCookie = getCookie('uticketPrivateLinkName');  

  const event = useEventData();
  const {
    getEventCartItemsAdded,
    getEventCartTotal,
    getEventCartTotalTickets,
    reinitializeEventCart,
  } = useCartStore();
  const { eventID } = useParams();
  const { clearEventCheckout } = useCheckoutStore();

  const goToPage = useCallback(() => {
    navigate('/me/tickets');
  }, [navigate]);

  

  useEffect(() => {
    if (event) {
      const total = getEventCartTotal(event?.id);
      const cartItemsAdded = getEventCartItemsAdded(event.id);
      const totalTickets = getEventCartTotalTickets(event.id);
      const contents = {
        id: event.id,
        quantity: totalTickets,
      };

      // @ts-ignore
      window.dataLayer.push({
        price: total,
        eventName: event.name,
        items: cartItemsAdded,
        quantityTotal: totalTickets,
        quantity: cartItemsAdded.length,
      });

      if (
        event?.integrations?.pixelId &&
        window.location.href.includes(event.id)
      ) {
        ReactPixel.trackSingle(event.integrations?.pixelId, 'Purchase', {
          content_type: 'product',
          content_ids: [event.id],
          value: getEventCartTotal(event.id),
          contents: contents,
          num_items: totalTickets,
          content_name: event.name,
          currency: 'BRL',
        });
      }

      const purchaseReactGA4 = {
        item_category: 'product',
        item_list_id: event.id,
        quantity: totalTickets,
        item_name: event.name,
      };

      ReactGA4.event('purchase', {
        currency: 'BRL',
        value: getEventCartTotal(event.id),
        items: [purchaseReactGA4],
      });
    }
  }, [
    event,
    getEventCartItemsAdded,
    getEventCartTotal,
    getEventCartTotalTickets,
  ]);

  useEffect(() => {
    if(existingCookie) {
      const timeoutId = setTimeout(() => {
        deleteCookie('uticketPrivateLinkName');
      }, 0);

      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, [existingCookie])

  useEffect(() => {
    reinitializeEventCart(eventID!, event?.ticketTypes);
    clearEventCheckout(eventID!)
  }, [clearEventCheckout, event?.ticketTypes, eventID, reinitializeEventCart]);

  useEffect(() => {
    if (!event) {
      goToPage();
    }
  }, [event, goToPage]);

  useEffect(() => {
    if (event?.id) {
      reinitializeEventCart(event?.id, event?.ticketTypes);
    }
  }, [event?.id, event?.ticketTypes, reinitializeEventCart]);

  return (
    <ColoredOverlayWindow
      show={true}
      title="Compra efetuada!"
      requestStatus="success"
      goToPage={goToPage}
      buttonText={undefined}>
      {`Você já tem acesso aos seus ingressos para ${
        event?.name ?? ''
      }. Para vê-los, vá para 'Meus ingressos'.`}
    </ColoredOverlayWindow>
  );
};

export default CheckoutSuccess;
